/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The question component type

Values: 0=Number, 1=ShortText, 2=Radio, 3=Checkbox, 4=DatePicker, 5=Email, 6=Files, 7=Select, 8=Slider, 9=RichTextBox, 10=Table, 11=MultiInput
 * @export
 * @enum {number}
 */

export enum QuestionComponentType {
    Number = 0,
    ShortText = 1,
    Radio = 2,
    Checkbox = 3,
    DatePicker = 4,
    Email = 5,
    Files = 6,
    Select = 7,
    Slider = 8,
    RichTextBox = 9,
    Table = 10,
    MultiInput = 11
}


